import engineUtilsService from './util/engine-utils.service';
import enginePropertyService from './property/engine-property.service';
import engineFieldsService from './field/engine-fields.service';
import engineRegistersService from './register/engine-registers.service';
import engineCellsService from './cell/engine-cells.service';
import { cloneViewField } from './src/cloneViewField';

engineService.$inject = ['ElementEdicom', 'injectorService'];

export default function engineService(ElementEdicom, injectorService) {
  return function generateFormHtml(formBuilderApi) {
    return new Promise(resolve => {
      const elementEdicom = new ElementEdicom('div').addAttribute('ec-responsive');
      const flashs = {};
      const modelsToInit = {};
      const engineApi = {
        data: formBuilderApi.data,
        model: formBuilderApi.view.model,
        name: formBuilderApi.name,
        registerName: formBuilderApi.view.name || 'root', // para state ocultar sections
        cache: formBuilderApi.cache,
        dictionary: formBuilderApi.dictionary,
        options: formBuilderApi.options,
        view: formBuilderApi.view,
        viewParent: formBuilderApi.view, // init de parent
        events: formBuilderApi.events,
        field: engineFieldsService,
        register: engineRegistersService,
        cell: engineCellsService,
        utils: engineUtilsService,
        property: enginePropertyService,
        Element: ElementEdicom,
        dispatcher: formBuilderApi.dispatcher,
        allowInvalid: formBuilderApi.allowInvalid,
        sections: formBuilderApi.sections,
        cloneViewField,
        handleProperties: handleProperties,
        setHiddenFields: args => console.warn('setHiddenFields is deprecated. No hace falta hacerlo, borrar las lineas que lo llaman. Llamado para ', args),
        getParent: model => {
          const parentModel = engineUtilsService.getParent(model);
          return engineApi.dictionary[parentModel] || {};
        },
        preload: preloadFn => formBuilderApi._preloads.push(preloadFn),
        watch: formBuilderApi.watch,
        _modelsToInit: modelsToInit,
        // _flash: flashs,
        registerFbFlash: model => {
          const name = `flashFn${Math.floor(Math.random() * 999999 + 1)}`;
          flashs[model] = true;
          return name;
        },
      };
      //
      handleSections(formBuilderApi.view, engineApi, elementEdicom);
      //
      formBuilderApi._html = elementEdicom.toString();
      formBuilderApi._flash = flashs;
      resolve({ modelsToInit });
    });
  };

  //////////////////////////////////////////////////////////////////////////////

  function handleSections(view, engineApi, parent) {
    view.properties.forEach(viewField => {
      engineApi.sectionName = viewField.name;
      viewField.isCollapse = viewField.type === 'collapse';
      viewField.type = 'section'; // forzamos el tipo a "section"
      parent.append(handleField(viewField, engineApi));
    });
  }

  function handleProperties(viewField, engineApi) {
    const register = new ElementEdicom('div');
    const engineApiExtended = extendOptions(engineApi, viewField);
    const properties = viewField.properties || [];

    properties.forEach(viewFieldChild => {
      register.append(handleField(viewFieldChild, engineApiExtended));
    });
    return register.getChilds();
  }

  function handleField(viewField, engineApi) {
    if (viewField.properties && !viewField.name) {
      console.error('Falta el "name" en ', viewField, ' Corregir este error que pasara a ser bloqueante en proximas versiones del formBuilder.');
    }
    const generate = injectorService.generate(viewField.type) || (() => '');
    return generate(viewField, engineApi);
  }

  function extendOptions(engineApi, viewField) {
    const copy = Object.assign({}, engineApi);
    copy.options = Object.assign({}, engineApi.options, viewField.options);
    copy.registerName = viewField.name;
    return copy;
  }
}
